// extracted by mini-css-extract-plugin
export default {"InputWrapper":"InputWrapper_InputWrapper__UUgfJ","label":"InputWrapper_label__D7EMv"};